import React from "react";
import { Row, Col } from "reactstrap";

const RotorSystem_Ours = () => {
  return (
    <>
      <Row>
        <Col xs={12} lg={4} md={12} className="text-center text-lg-left d-flex align-items-center mb-4 mb-md-0 order-lg-1 order-1">
          <p style={{ color: "white", fontSize: '1.25em', marginBottom: '20px'}}>
            <span style={{ fontSize: '1.75em', color: "white"}}>Our Rotor System<br/><br/></span>
            MagLev HyperDrive&trade; is a specialized rotor system designed to operate at significantly lower speeds and lower blade loading: with many more blades, the system can achieve significantly higher efficiencies and lower noise levels than both helicopters and multi-rotor eVTOLs.
          </p>
        </Col>
        <Col xs={12} lg={8} md={12} className="text-center d-flex align-items-center mb-4 mb-md-0 order-md-1 order-sm-1 order-xs-1 order-1">
        <div className="embed-responsive embed-responsive-16by9" style={{ color: "white", fontSize: '1.25em', marginBottom: '20px'}} >
          <iframe
            title="TheRotors-MaglevSolution"
            src="https://player.vimeo.com/video/896276863?h=d28d97b7c2"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            className="embed-responsive-item"
          ></iframe>
        </div>
        </Col>
      </Row>
    </>
  );
};

export default RotorSystem_Ours;
